import { SeriesOptionsType } from "highcharts";

export type MtuUsageData = {
  byMonth: MtuUsageByMonthData[];
  byEnv: MtuUsageByEnvData[];
};

export type MtuUsageByMonthData = {
  year: number;
  month: number;
  yearMonth: string;
  mtuUsage: number;
  contractedMtu: number;
};

export type MtuUsageByEnvData = {
  projectID: string;
  projectName: string;
  envID: string;
  envName: string;
  year: number;
  month: number;
  yearMonth: string;
  mtuUsage: number;
};

export type DataSeries = SeriesOptionsType & {
  name: string;
  data: number[];
};

export type DestinationUsageData = {
  eventDefCount: number;
  destinationUsageByEnv: DestinationUsageByEnvData[];
};

export type DestinationUsageByEnvData = {
  accountID: string;
  projID: string;
  projName: string;
  envID: string;
  envName: string;
  destination: string;
};

export type DestinationTableSortColumnName =
  | "projName"
  | "envName"
  | "destination";

export const mtuUsageTableTitles = ["", "MTU Usage", "Contracted MTU"];
